import { getParameter } from "./getParameter";
import { subscribe } from "./messageBus";
import * as overridesJson from "./currency/formatOverrides.json";
const formatters = new Map();
let betMultiplier = 1;
let currency = undefined;
subscribe("configure", (configuration) => {
    var _a;
    if (configuration.currencyCode !== undefined) {
        currency = configuration.currencyCode;
    }
    if (((_a = configuration.loginResponse) === null || _a === void 0 ? void 0 : _a.betMultiplier) !== undefined) {
        betMultiplier = configuration.loginResponse.betMultiplier;
    }
});
const createFormatter = (flags, formatterCurrency) => {
    var _a, _b, _c, _d;
    if (!formatters.has(formatterCurrency)) {
        formatters.set(formatterCurrency, new Map());
    }
    const style = flags & 1
        ? "decimal"
        : "currency";
    const options = {
        style,
        currency: formatterCurrency
    };
    if (!(flags & 2) && betMultiplier % 100 !== 0) {
        options.minimumFractionDigits = 2;
    }
    else {
        options.minimumFractionDigits = 0;
    }
    const fallbackLocale = "en-US";
    const currencyToLocaleOverrideMap = overridesJson;
    const currencyLocale = (_c = (_a = currencyToLocaleOverrideMap[formatterCurrency]) !== null && _a !== void 0 ? _a : (_b = getParameter("lang")) === null || _b === void 0 ? void 0 : _b.toLowerCase().replace("_", "-")) !== null && _c !== void 0 ? _c : fallbackLocale;
    const createValidFormatter = (formatterLocale, formatterOptions) => {
        try {
            return Intl.NumberFormat(formatterLocale, formatterOptions);
        }
        catch (error) {
            if (formatterOptions.style === "currency") {
                return createValidFormatter(formatterLocale, Object.assign(Object.assign({}, formatterOptions), { currency: undefined, style: "decimal" }));
            }
            else if (formatterLocale !== fallbackLocale) {
                return createValidFormatter(fallbackLocale, options);
            }
            else {
                return Intl.NumberFormat(fallbackLocale, Object.assign(Object.assign({}, formatterOptions), { currency: undefined, style: "decimal" }));
            }
        }
    };
    const formatter = createValidFormatter(currencyLocale, options);
    (_d = formatters.get(formatterCurrency)) === null || _d === void 0 ? void 0 : _d.set(flags, formatter);
    return formatter;
};
function getFormatter(flags, formatterCurrency) {
    var _a, _b;
    return (_b = (_a = formatters.get(formatterCurrency)) === null || _a === void 0 ? void 0 : _a.get(flags)) !== null && _b !== void 0 ? _b : createFormatter(flags, formatterCurrency);
}
export const formatCurrency = (cents, options) => {
    var _a;
    let flags = 0;
    if (cents % 100 !== 0) {
        flags &= ~2;
    }
    else if ((options === null || options === void 0 ? void 0 : options.noTrailingZeroes) === true) {
        flags |= 2;
    }
    const formatterCurrency = (_a = options === null || options === void 0 ? void 0 : options.currency) !== null && _a !== void 0 ? _a : currency;
    if (formatterCurrency === undefined || formatterCurrency === "FUN" || (options === null || options === void 0 ? void 0 : options.noCurrencySymbol) === true) {
        flags |= 1;
    }
    const result = getFormatter(flags, formatterCurrency !== null && formatterCurrency !== void 0 ? formatterCurrency : "none").format(cents / 100);
    return result;
};
